exports = module.exports = require('./commonjs/read/readXlsxFileBrowser').default
exports['default'] = require('./commonjs/read/readXlsxFileBrowser').default
exports.parseExcelDate = require('./commonjs/read/parseDate').default
exports.Integer = require('./commonjs/types/Integer').default
exports.Email = require('./commonjs/types/Email').default
exports.URL = require('./commonjs/types/URL').default



//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/index.commonjs.js
// module id = 754
// module chunks = 1